import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';

import * as RoutePermissionActions from '../actions/routePermission.actions';
import { RoutePermissionService } from '../../service/routePermission.service';

@Injectable()
export class RoutePermissionEffects {

    constructor(
        private actions$: Actions,
        private routePermissionService: RoutePermissionService
    ) {}

    loadRoutePermissions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(RoutePermissionActions.LoadRoutePermissions),
            switchMap(() => {
                const params = new HttpParams();
                
                return this.routePermissionService.getRoutePermissions(params).pipe(
                    map(response => {
                        const routePermissions = response.results || [];
                        this.routePermissionService.routeFeaturePermissions.next(routePermissions); // Sync avec BehaviorSubject pour compatibilité
                        return RoutePermissionActions.LoadRoutePermissionsSuccess({ routePermissions });
                    }),
                    catchError(error => {
                        return of(RoutePermissionActions.LoadRoutePermissionsFailure({ error: error.message }));
                    })
                );
            })
        )
    );
}
